module.exports = __webpack_public_path__ + "img/girlandcat.a5cdcec6.svg";